import { render } from "./UploadDetailsModal.vue?vue&type=template&id=0c6b666b&scoped=true"
import script from "./UploadDetailsModal.vue?vue&type=script&lang=js"
export * from "./UploadDetailsModal.vue?vue&type=script&lang=js"

import "./UploadDetailsModal.vue?vue&type=style&index=0&id=0c6b666b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6b666b"]])

export default __exports__